import ClipboardAction from 'clipboard/lib/clipboard-action';

/* istanbul ignore next */
const FAKE_EMITTER = { emit: () => null };

export default function copyToClipboard(text: string): void {
  /* tslint:disable:no-unused-expression */
  new ClipboardAction({
    text,
    action: 'copy',
    container: document.body,
    emitter: FAKE_EMITTER,
  });
}
